import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Upload as UploadAntd,
  Image,
  DatePicker,
  Space,
  Radio,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import Noimage from "../assets/images/noimage_newww.png";
import * as XLSX from "xlsx";
import moment from "moment";
import apiPath from "../constants/apiPath";
import {
  ExclamationCircleOutlined,
  FilterFilled,
  UploadOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import DescriptionEditor from "../components/DescriptionEditor";

import { AuthContext } from "../context/AuthContext";
import { uploadViaBackend } from "../helper/uploadViaBackend";
import PhoneinputField from "../components/PhoneInputField";
import lang from "../helper/lang";
import SingleImageUpload from "../components/SingleImageUpload";
import MultipleImageUpload from "../components/MultipleImageUpload";
import notfound from "../assets/images/not_found.png";

import { Select } from "antd";
import { noLeadingSpace, noStartSpace } from "../helper/functions";
const { Option } = Select;
const answerTypes = [
  { label: "Free Text", value: "text" },
  { label: "Select from predefined values", value: "select" },
];
const { RangePicker } = DatePicker;
const defaultContent = () => ({
  id: Date.now(),
  title: "",
  ar_title: "",
  description: "",
  ar_description: "",
  report: "",
});

const Search = Input.Search;
let baseURL = "/admin/content";

function Survey({ type }) {
  const { userPermission, userProfile } = useContext(AuthContext) || {
    userPermission: [],
  };

  const isAdmin = userProfile?.type || "";
  let permissionObject = {
    add: true,
    edit: true,
    delete: true,
  };
  // const permissionMap = (userPermission ?? []).reduce((acc, item) => {
  //   acc[item.name] = item;
  //   return acc;
  // }, {});
  // console.log(permissionMap)

  // if(isAdmin !== "Admin" && permissionMap["gamerManager"]) {
  //   permissionObject.add = permissionMap["gamerManager"].add;
  //   permissionObject.edit = permissionMap["gamerManager"].edit;
  //   permissionObject.delete =  permissionMap["gamerManager"].view;
  //   console.log(permissionMap["gamerManager"]);
  //   console.log(permissionObject);
  // }
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [file, setFile] = useState([]);
  const [certificateModalVisible, setCertificateModalVisible] = useState(false);
  const [certificateCP, setCertificateCP] = useState(null);
  const [image, setImage] = useState(null);
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const columns = [
    {
      title: "Name",
      render: (_, { name, userName }) => {
        return <div>{name ? name : userName}</div>;
      },
    },
    {
      title: "Content Status",
      key: "contentStatus",
      dataIndex: "status", // change if your field is named differently
      filters: [
        { text: "Draft", value: "draft" },
        { text: "Published", value: "published" },
      ],
      onFilter: (value, record) => record.status === value,
      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (status) => {
        let color = status === "published" ? "green" : "orange";
        return <Tag color={color}>{status?.toUpperCase()}</Tag>;
      },
    },
    {
      title: "STATUS",
      key: "isActive",
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "InActive",
          value: false,
        },
      ],
      onFilter: (value, record) => record.isActive === value,
      // filtered: true,
      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (_, { is_deleted, isActive, _id }) => {
        let color = is_deleted ? "red" : isActive ? "green" : "red";
        return (
          <Tag
            onClick={(e) => (!is_deleted ? showConfirm(_id) : null)}
            color={color}
            key={isActive}
          >
            {is_deleted ? "DELETED" : isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
    {
      title: "Registration date",
      key: "createdAt",
      dataIndex: "createdAt",
      render: (_, { createdAt }) => {
        return new Date(createdAt).toLocaleDateString();
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <>
            <div className="cta_wrap">
              <Button title="Edit" onClick={() => handleEdit(record)}>
                <i className="fa fa-pen" />
              </Button>
              {/* <Button
                danger
                style={{ marginLeft: 8 }}
                title="Delete"
                onClick={() => {
                  Modal.confirm({
                    // title: "Are you sure you want to delete this practitioner?",
                    content: "Are you sure you want to delete this practitioner?",
                    icon: <ExclamationCircleOutlined />,
                    okText: "Yes",
                    cancelText: "No",
                    onOk: () => deleteAccount(record),
                  });
                }}
              >
                <i className="fa fa-trash"></i>
              </Button> */}
              <Button
                style={{ marginLeft: 8 }}
                title="View"
                onClick={() => {
                  setViewData(record);
                  setVisibleView(true);
                }}
              >
                <i className="fa fa-eye"></i>
              </Button>
            </div>
          </>
        );
      },
    },
  ];
  const handleEdit = (record) => {
    navigate(`/content/edit/${record._id}`, { state: { record } });
  };
  useEffect(() => {
    if (certificateModalVisible && certificateCP?.certifications) {
      setImage(certificateCP.certifications); // assume this is the URL
    }
  }, [certificateModalVisible, certificateCP]);
  const uploadFileToS3 = async (file) => {
    // Uploads go through the backend (no S3 keys in the browser).
    return await uploadViaBackend(file, "realState/admin");
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  const deleteAccount = (record) => {
    // alert(record._id)
    request({
      url: `${baseURL}/delete-account/${record ? record._id : ""}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data, "data");
        setRefresh(!refresh);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-content/${viewData._id}`);
  }, [visibleView]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : rowFilter.isActive;
    request({
      url: `${baseURL}/list?status=${
        filterActive ? filterActive.join(",") : ""
      }&page=${pagination ? pagination.current : 1}&limit=${
        pagination ? pagination.pageSize : 10
      }&search=${debouncedSearchText}&start_date=${
        startDate ? startDate : ""
      }&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const handleImage = (data) => {
    const url = data?.[0]?.url || "";
    setImage(url);
  };

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    }
  };

  const handleCertificationSubmit = (values) => {
    const payload = { image: image };

    request({
      url: `${baseURL}/certifications/${values}`,
      method: "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast("Certification submitted successfully!", Severty.SUCCESS);
        fetchData(pagination); // Refresh the data after submission
      },
    });

    setImage(null); // Reset image after submission
  };

  return (
    <>
      <div className="tabled">
        <Row>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Content Manager"
              extra={
                <>
                  <Search
                    size="large"
                    placeholder="Search by Name"
                    onChange={onSearch}
                    title="Search by Name"
                    value={searchText}
                    onPressEnter={onSearch}
                  />
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination?.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddForm
          file={file}
          setFile={setFile}
          handleChangeImage={handleChangeImage}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {provideSession && (
        <ChangePassword
          show={provideSession}
          hide={() => {
            setSelected();
            setProvideSession(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      <Modal
        title="Comming Soon......"
        open={isRKModalVisible}
        onOk={() => setIsRKModalVisible(false)}
        onCancel={() => setIsRKModalVisible(false)}
      >
        <p>{modalContent}</p>
      </Modal>

      {certificateModalVisible && (
        <Modal
          open={certificateModalVisible}
          title={
            certificateCP.certifications
              ? "Edit CP Certificate"
              : "Create CP Certificate"
          }
          onCancel={() => setCertificateModalVisible(false)}
          footer={null}
        >
          {/* Certificate form goes here */}
          <p>
            Certificate management for:{" "}
            <b>{certificateCP?.name || certificateCP?.userName}</b>
          </p>

          <SingleImageUpload
            value={image}
            fileType={FileType}
            imageType={"Profile"}
            btnName={" Logo"}
            onChange={(data) => handleImage(data)}
            isDimension={false}
          />

          <p className="img-size-details">
            ** Certificate should be in (.png, .jpeg, .jpg .pdf ) format and up
            to 5 MB **
          </p>

          {image && (
            <div className="mt-2 add-img-product mb-4">
              {image.endsWith(".pdf") ? (
                <a href={image} target="_blank" rel="noopener noreferrer">
                  View PDF
                </a>
              ) : (
                <Image width={120} src={image} />
              )}
            </div>
          )}

          <Button
            onClick={() => {
              // Handle certificate submission logic here

              handleCertificationSubmit(certificateCP?._id);
              setCertificateModalVisible(false);
            }}
          >
            Submit
          </Button>
          {/* You can add a form here for certificate details, upload, etc. */}
          {/* On submit, call your API to create/edit certificate */}
        </Modal>
      )}
    </>
  );
}

const AddForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [contents, setContents] = useState("");
  const [status, setStatus] = useState("draft");

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        name: data.name,
        description: data.description,
      });
      setContents(data.description || "");
      setStatus(data.status || "draft");
    } else {
      form.resetFields();
      setContents("");
      setStatus("draft");
    }
  }, [data]);

  const onFinish = (values) => {
    const payload = {
      name: values.name,
      contents,
      status,
    };

    request({
      url: data ? `/admin/content/edit/${data._id}` : `/admin/content/add`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: () => {
        ShowToast("Content saved successfully", Severty.SUCCESS);
        hide();
        refresh?.();
      },
      onError: (err) => {
        ShowToast(
          err?.response?.data?.message || "Failed to save content",
          Severty.ERROR
        );
      },
    });
  };

  return (
    <Modal
      open={show}
      onCancel={hide}
      title={data ? "Edit Content" : "Add New Content"}
      footer={null}
      width={900}
    >
      <Form
        layout="vertical"
        form={form}
        id="add-content-form"
        onFinish={onFinish}
      >
        <Form.Item
          label="Content Title"
          name="name"
          rules={[
            { required: true, message: "Name is required" },
            { validator: noLeadingSpace },
          ]}
        >
          <Input placeholder="e.g. About Us, Terms & Conditions..." />
        </Form.Item>

        <Form.Item
          label="Description (English)"
          name="description"
          rules={[
            { required: true, message: "Description is required" },
            { validator: noStartSpace },
          ]}
          valuePropName="value"
          getValueFromEvent={(content) => content}
        >
          <DescriptionEditor
            placeholder="Enter content description..."
            value={contents}
            onChange={(val) => setContents(val)}
          />
        </Form.Item>

        <Form.Item label="Status">
          <Radio.Group
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            buttonStyle="solid"
          >
            <Radio.Button value="draft">Save as Draft</Radio.Button>
            <Radio.Button value="published">Publish</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item>
          <Button htmlType="submit" type="primary" block>
            {data ? "Update Content" : "Create Content"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const ChangePassword = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [contents, setContents] = useState([]);
  const [reportTypes, setReportTypes] = useState([]);

  useEffect(() => {
    setReportTypes(["Feedback Report", "Summary", "General Report"]);
  }, []);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({ name: data.name });
      setContents(data.contents || []);
    } else {
      form.resetFields();
      setContents([]);
    }
  }, [data]);

  const addContentBlock = () => {
    setContents([...contents, defaultContent()]);
  };

  const removeContent = (index) => {
    const updated = [...contents];
    updated.splice(index, 1);
    setContents(updated);
  };

  const moveContent = (from, to) => {
    if (to < 0 || to >= contents.length) return;
    const updated = [...contents];
    const [moved] = updated.splice(from, 1);
    updated.splice(to, 0, moved);
    setContents(updated);
  };

  const handleChange = (index, key, value) => {
    const updated = [...contents];
    updated[index][key] = value;
    setContents(updated);
  };

  const onFinish = (values) => {
    const payload = {
      name: values.name,
      contents,
    };

    request({
      url: data ? `/admin/content/edit/${data._id}` : `/admin/content/add`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: () => {
        ShowToast("Content saved successfully", Severty.SUCCESS);
        hide();
        refresh?.();
      },
      onError: (err) => {
        ShowToast(
          err?.response?.data?.message || "Failed to save content",
          Severty.ERROR
        );
      },
    });
  };

  return (
    <Modal
      open={show}
      onCancel={hide}
      title={data ? "Edit Content" : "Add New Content"}
      okButtonProps={{ form: "add-content-form", htmlType: "submit" }}
      footer={null}
      width={900}
    >
      <Form
        layout="vertical"
        form={form}
        id="add-content-form"
        onFinish={onFinish}
      >
        <Form.Item
          label="Content Set Name"
          name="name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder="e.g. Legal Pages, Help Center..." />
        </Form.Item>

        <div style={{ marginBottom: 16 }}>
          <b>Pages / Sections</b>
          <Button icon={<PlusOutlined />} type="link" onClick={addContentBlock}>
            Add Section
          </Button>
        </div>

        {contents.map((block, index) => (
          <Card
            key={block.id}
            size="small"
            style={{ marginBottom: 12 }}
            title={`Section ${index + 1}`}
            extra={
              <Space>
                <Button
                  icon={<ArrowUpOutlined />}
                  onClick={() => moveContent(index, index - 1)}
                />
                <Button
                  icon={<ArrowDownOutlined />}
                  onClick={() => moveContent(index, index + 1)}
                />
                <Button
                  icon={<DeleteOutlined />}
                  danger
                  onClick={() => removeContent(index)}
                />
              </Space>
            }
          >
            <Row gutter={12}>
              <Col span={12}>
                <Input
                  placeholder="Title (English)"
                  value={block.title}
                  onChange={(e) => handleChange(index, "title", e.target.value)}
                  style={{ marginBottom: 8 }}
                />
              </Col>
              <Col span={12}>
                <Input
                  placeholder="Title (Arabic)"
                  value={block.ar_title}
                  onChange={(e) =>
                    handleChange(index, "ar_title", e.target.value)
                  }
                  style={{ marginBottom: 8 }}
                />
              </Col>
            </Row>

            <Row gutter={12}>
              <Col span={24}>
                <DescriptionEditor
                  value={block.description}
                  placeholder="Description (English)"
                  onChange={(val) => handleChange(index, "description", val)}
                />
              </Col>
              <Col span={24} style={{ marginTop: 12 }}>
                <DescriptionEditor
                  value={block.ar_description}
                  placeholder="Description (Arabic)"
                  onChange={(val) => handleChange(index, "ar_description", val)}
                />
              </Col>
            </Row>

            <Row gutter={12} style={{ marginTop: 12 }}>
              <Col span={24}>
                <Select
                  value={block.report}
                  onChange={(val) => handleChange(index, "report", val)}
                  style={{ width: "100%" }}
                  placeholder="Link to Report (optional)"
                  allowClear
                >
                  {reportTypes.map((r) => (
                    <Option key={r} value={r}>
                      {r}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </Card>
        ))}

        <Form.Item>
          <Button htmlType="submit" type="primary" block>
            {data ? "Update Content" : "Create Content"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Survey;
